import { createSvgIcon } from 'shared/icons/IconUtils';

export const RobotIcon = createSvgIcon(
  'Robot',
  <g
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="8" width="16" height="12" rx="3" />
    <path d="M12 8V4" />
    <circle cx="12" cy="3" r="1" />
    <path d="M9 13v1.5M15 13v1.5M2 13v3M22 13v3" />
  </g>,
  { viewBox: '0 0 24 24', 'aria-hidden': true },
);
